import { DateTime } from 'luxon';
export class DateHelper {
    static isDayBeforeDate(isoDateToCheckAgainst) {
        const today = DateTime.utc();
        const dateToCheckAgainstUTC = DateTime.fromISO(isoDateToCheckAgainst).toUTC();
        const lastDay = dateToCheckAgainstUTC.minus({ days: 1 });
        return today.hasSame(lastDay, 'day') && today.hasSame(lastDay, 'month') && today.hasSame(lastDay, 'year');
    }
    static isSameDay(isoDateToCheckAgainst) {
        const today = DateTime.utc();
        const dateToCheckAgainstUTC = DateTime.fromISO(isoDateToCheckAgainst).toUTC();
        return today.hasSame(dateToCheckAgainstUTC, 'day');
    }
    static getDateRange(daysToSubtract, initialDateIso) {
        let initialDateUTC;
        let periodEnd;
        if (initialDateIso) {
            initialDateUTC = DateTime.fromISO(initialDateIso).toUTC();
            periodEnd = DateTime.fromISO(initialDateIso).toUTC();
        }
        else {
            initialDateUTC = DateTime.utc();
            periodEnd = DateTime.utc();
        }
        const beginning = initialDateUTC.minus({ days: daysToSubtract });
        const beginningMs = beginning.valueOf();
        const beginningIso = beginning.toISO();
        const endMs = periodEnd.valueOf();
        const endIso = periodEnd.toISO();
        const dates = {
            beginningMs,
            beginningIso,
            endMs,
            endIso,
        };
        return dates;
    }
    static todayUtcIso() {
        return DateTime.utc().toISO();
    }
    static todayUtcMs() {
        return DateTime.utc().valueOf();
    }
}
//# sourceMappingURL=date-helper.js.map